function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcon = function SvgIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "m94.718 46.041 6.205-6.205c-1.966-2.228-3.933-4.238-6.161-6.16l-6.205 6.291C81.784 34.462 73.263 31.228 64 31.228c-21.717 0-39.326 17.61-39.326 39.326S42.284 109.88 64 109.88c21.848 0 39.326-17.61 39.326-39.326 0-9.263-3.234-17.784-8.608-24.513m-26.35 28.883H59.63V44.337h8.739zm8.739-56.805H50.89v8.74h26.218z",
    className: "icon_svg__black",
    style: {
      fill: "#fc0"
    }
  }));
};
export default SvgIcon;